import React from 'react';
import Nav from '../../components/Nav';

const Navbar = () => (
  <div>
    <Nav />
  </div>
);

export default Navbar;
